__turbopack_export_value__({
  "body-logo-18": "PromotionsCard-module-scss-module__Tg7txG__body-logo-18",
  "body-text-12": "PromotionsCard-module-scss-module__Tg7txG__body-text-12",
  "body-text-14": "PromotionsCard-module-scss-module__Tg7txG__body-text-14",
  "body-text-16": "PromotionsCard-module-scss-module__Tg7txG__body-text-16",
  "body-text-18": "PromotionsCard-module-scss-module__Tg7txG__body-text-18",
  "body-text-20": "PromotionsCard-module-scss-module__Tg7txG__body-text-20",
  "body-text-24": "PromotionsCard-module-scss-module__Tg7txG__body-text-24",
  "body-text-24-2": "PromotionsCard-module-scss-module__Tg7txG__body-text-24-2",
  "body-text-heading-2": "PromotionsCard-module-scss-module__Tg7txG__body-text-heading-2",
  "body-text-heading-3": "PromotionsCard-module-scss-module__Tg7txG__body-text-heading-3",
  "body-text-medium-14": "PromotionsCard-module-scss-module__Tg7txG__body-text-medium-14",
  "body-text-medium-16": "PromotionsCard-module-scss-module__Tg7txG__body-text-medium-16",
  "body-text-medium-18": "PromotionsCard-module-scss-module__Tg7txG__body-text-medium-18",
  "body-text-medium2-18": "PromotionsCard-module-scss-module__Tg7txG__body-text-medium2-18",
  "body-text2-14": "PromotionsCard-module-scss-module__Tg7txG__body-text2-14",
  "body-text2-16": "PromotionsCard-module-scss-module__Tg7txG__body-text2-16",
  "button-primary-text": "PromotionsCard-module-scss-module__Tg7txG__button-primary-text",
  "button-text": "PromotionsCard-module-scss-module__Tg7txG__button-text",
  "button2-text": "PromotionsCard-module-scss-module__Tg7txG__button2-text",
  "card": "PromotionsCard-module-scss-module__Tg7txG__card",
  "card-shadow": "PromotionsCard-module-scss-module__Tg7txG__card-shadow",
  "card__button": "PromotionsCard-module-scss-module__Tg7txG__card__button",
  "card__date": "PromotionsCard-module-scss-module__Tg7txG__card__date",
  "card__imageWrapper": "PromotionsCard-module-scss-module__Tg7txG__card__imageWrapper",
  "card__title": "PromotionsCard-module-scss-module__Tg7txG__card__title",
  "effect-menu": "PromotionsCard-module-scss-module__Tg7txG__effect-menu",
  "header-1": "PromotionsCard-module-scss-module__Tg7txG__header-1",
  "main-container": "PromotionsCard-module-scss-module__Tg7txG__main-container",
  "main-footer-container": "PromotionsCard-module-scss-module__Tg7txG__main-footer-container",
  "main-header-container": "PromotionsCard-module-scss-module__Tg7txG__main-header-container",
  "txt-12-bold": "PromotionsCard-module-scss-module__Tg7txG__txt-12-bold",
  "txt-14-bold": "PromotionsCard-module-scss-module__Tg7txG__txt-14-bold",
  "txt-14-bold-caps": "PromotionsCard-module-scss-module__Tg7txG__txt-14-bold-caps",
  "txt-14-med": "PromotionsCard-module-scss-module__Tg7txG__txt-14-med",
  "txt-16-bold": "PromotionsCard-module-scss-module__Tg7txG__txt-16-bold",
  "txt-16-med": "PromotionsCard-module-scss-module__Tg7txG__txt-16-med",
  "txt-18-bold": "PromotionsCard-module-scss-module__Tg7txG__txt-18-bold",
  "txt-18-medium": "PromotionsCard-module-scss-module__Tg7txG__txt-18-medium",
  "txt-18-medium-24": "PromotionsCard-module-scss-module__Tg7txG__txt-18-medium-24",
  "txt-24-semi": "PromotionsCard-module-scss-module__Tg7txG__txt-24-semi",
});
